// Module
var code = "<template> <require from=\"./breadcrumbs.scss\"></require> <slot></slot> </template> ";
// Exports
export default code;